<template>
  <a-card :bordered="false">
    <!-- 表格筛选 start -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <!-- 输入关键词查找 -->
          <a-col :md="6" :sm="24">
            <a-form-item label="日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-date-picker :disabled-date="disabledDate" :default-value="moment(queryParam.stime, dateFormat)" @change="onChange" />
            </a-form-item>
          </a-col>
          <a-col :md="18" :sm="24">
            <ul style="float:left;margin-top:-2px;" unselectable="unselectable" class="ant-pagination ant-table-pagination">
              <li title="上一页" aria-disabled="true" :class="queryParam.page === 1 ? 'ant-pagination-disabled ant-pagination-prev':'ant-pagination-prev'"  @click="changePage(queryParam.page - 1)">
                <a class="ant-pagination-item-link">
                  <i class="anticon anticon-left">
                    <svg viewBox="64 64 896 896" data-icon="left" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class="">
                      <path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path>
                    </svg>
                  </i>
                </a>
              </li>
              <li v-for="page in data.totalPage" :key="page" :title="page" :class="queryParam.page === page?'ant-pagination-item ant-pagination-item-active':'ant-pagination-item'" @click="changePage(page)">
                <a>{{ page }}</a>
              </li>
              <li title="下一页" tabindex="0" :class="queryParam.page >= data.totalPage ? 'ant-pagination-disabled ant-pagination-next':'ant-pagination-next'" @click="changePage(queryParam.page + 1)">
                <a class="ant-pagination-item-link">
                  <i class="anticon anticon-right">
                    <svg viewBox="64 64 896 896" data-icon="right" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class="">
                      <path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z"></path>
                    </svg>
                  </i>
                </a>
              </li>
            </ul>
          </a-col>
          <template v-if="advanced">
          </template>
          <!-- 展开或者收起筛选项 start -->
          <!-- <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" htmlType="submit">查询</a-button>
            </span>
          </a-col> -->
          <!-- 展开或者收起筛选项 end -->
        </a-row>
      </a-form>
    </div>
    <!-- 表格筛选 end -->
    <!-- 表格内容操作 start -->
    <div class="table-operator">
    </div>
    <!-- 表格内容操作 end -->
    <!-- 表格 start -->
    <a-spin v-if="loading" />
    <div v-if="!loading" class="table-wrapper">
      <div class="ant-table-wrapper">
        <div class="ant-table ant-table-fixed-header ant-table-scroll-position-left ant-table-middle ant-table-layout-fixed ant-table-default">
          <div class="ant-table-content">
            <div class="ant-table-scroll">
              <div class="ant-table-header" style="margin-bottom:0px;padding-bottom:0px;min-width: 0px; overflow: hidden hidden;">
                <table class="ant-table-fixed">
                  <thead class="ant-table-thead">
                    <tr>
                      <th :style="isDesktop() ? 'width:9%;text-align:center;':'width:25%;text-align:center;'">时段 / 老师</th>
                      <th v-for="(teacher, i) in data.teachers" :key="i" :style="isDesktop() ? 'width:13%;': 'width:35%;'">
                        <div style="text-align:center;">
                          {{ teacher.english_name }}
                          <br />
                          <span style="font-size:12px;">{{ teacher.label  || '--' }}</span>
                          <br />
                          <span style="font-size:12px;">{{ teacher.introduce  || '--' }}</span>
                          <br />
                          <video :src="teacher.soundrecording" height="30px" width="120px" controls=""></video>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="ant-table-body" style="min-width:0px;max-height: 500px; overflow-y: scroll;">
                <table class="ant-table-bordered">
                  <colgroup>
                  <col><col><col><col><col><col>
                  </colgroup>
                  <tbody class="ant-table-tbody">
                    <tr v-for="(time, index) in data.arr" :key="index" class="ant-table-row" style="text-align:center">
                      <td :style="isDesktop() ? 'width:9%;':'width:30%;'">{{ time.time }}</td>
                      <td v-for="(state, ii) in time.data" :key="ii" :style="isDesktop() ? 'width:13%;': 'width:30%;'">
                        <!-- close -->
                        <a-button :id="'yy' + data.dateymd + ' ' + state.time + '_' + state.tid" v-if="state.state === 'close'" type="primary" disabled class="close_yy_btn">CLOSE</a-button>
                        <!-- booked -->
                        <a-button :id="'yy' + data.dateymd + ' ' + state.time + '_' + state.tid" v-if="state.state === 'booked'" type="primary" class="booked_yy_btn">BOOKED</a-button>
                        <!-- open -->
                        <a-button :id="'yy' + data.dateymd + ' ' + state.time + '_' + state.tid" @click="showYuyueModal(state)" v-if="state.state === 'open'" type="primary" class="open_yy_btn">OPEN</a-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 表格 end -->
    <!-- 预约弹窗 -->
    <yuyueModal ctname="菲教" :planDetail="planDetail" v-if="yuyueModalVisible" :visible="yuyueModalVisible" @hide="handelYuyueModal" @finish="finish"/>
  </a-card>
</template>
<script>
import moment from 'moment'
import { feijiaobooktime } from '@/api/subscribe'
import yuyueModal from './Modal/yuyueModal'
import { valInDict } from '@/utils/util'
import { TcgTable } from '@/components'
import { mixin, mixinDevice } from '@/utils/mixin'
import _ from 'lodash'

export default {
  components: {
    TcgTable,
    yuyueModal
  },
  mixins: [mixin, mixinDevice],
  data () {
    this.dateFormat = 'YYYY-MM-DD'
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18,
        offset: 1
      },
      advanced: false,
      // 查看抽屉状态开关
      viewVisible: false,
      // id
      id: '',
      // 字典
      dict: {},
      // 查询参数
      queryParam: {
        stime: moment().format(this.dateFormat),
        page: 1,
        size: 7
      },
      data: {
        arr: [],
        omtime: [],
        teachers: [],
        totalPage: 1
      },
      loading: false,
      changeData: {},
      yuyueModalVisible: false,
      nowRecord: {},
      planDetail: {
        tid: '',
        english_name: '',
        days: '',
        times: ''
      }
    }
  },
  created () {
    this.handleSubmit()
  },
  methods: {
    moment,
    // 重置按钮
    reset () {
      this.queryParam = {
        stime: '',
        page: 1,
        size: 7
      }
    },
    disabledDate(current) {
      return current > moment().add(1, 'month') || current < moment().subtract(1, 'days')
    },
    onChange(date, dateString) {
      console.log(date, dateString);
      if (dateString !== '') {
        this.queryParam.stime = dateString
        this.queryParam.page = 1
        this.handleSubmit()
      }
    },
    changePage(page){
      if (page < 1) {
        return false
      }
      if (page > this.data.totalPage) {
        return false
      }
      this.queryParam.page=page
      this.handleSubmit()
    },
    // 完成创建
    finish (bookedNextTime) {
      this.nowRecord.state = 'booked'
      // 判断下个时间段是否被占用
      if (bookedNextTime!=='') {
        const tid=this.nowRecord.tid
        const nextTimeYy = document.getElementById('yy'+bookedNextTime+'_'+tid)
        nextTimeYy.setAttribute('class', 'booked_yy_btn ant-btn ant-btn-primary')
        nextTimeYy.setAttribute('disabled', 'disabled')
        nextTimeYy.innerText = 'BOOKED'
      }
      // this.handleSubmit()
      this.handelYuyueModal()
    },
    // 打开添加抽屉
    showYuyueModal (record) {
      this.nowRecord = record
      const englishName = valInDict(record.tid, this.data.teachers, 'tid', 'english_name', '')
      this.planDetail={
        ctype: this.data.classifcation,
        tid: record.tid,
        english_name: englishName,
        days: this.data.dateymd,
        times: record.time
      }
      this.yuyueModalVisible = true
    },
    // 关闭添加抽屉
    handelYuyueModal () {
      this.yuyueModalVisible = false
    },
    // 提交筛选
    handleSubmit () {
      this.loading = true
      console.log(this.isDesktop())
      if (!this.isDesktop()) {
        this.queryParam.size = 2
      }
      feijiaobooktime(this.queryParam).then(res => {
        if (_.get(res, 'code') === 200) {
          this.data = _.get(res, 'values', {})
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .close_btn {
    background:#e6e6e6;
    color:#000000;
  }
  .close_yy_btn {
    background:#e6e6e6;
    color:#000000;
    margin-right:5px;
  }
  .open_btn {
    background-color: #3bb4f2;
    color:#3bb4f2;
    border-color:#3bb4f2;
    color:#ffffff;
  }
  .open_yy_btn {
    background-color: #3bb4f2;
    color:#3bb4f2;
    border-color:#3bb4f2;
    color:#ffffff;
    margin-right:5px;
  }
  .booked_btn {
    background:#5eb95e;
    color:#ffffff;
    border-color:#5eb95e;
  }
  .booked_yy_btn {
    background:#5eb95e;
    color:#ffffff;
    border-color:#5eb95e;
    margin-right:5px;
  }
</style>
